import React, { memo } from "react";
import { Pagination } from "@mui/material";
import { PaginationWrapper } from "./styles/PaginationsStyle";

const TablePaginations = ({
  // sortedData,
  // rowsPerPage,
  currentPage,
  handleChangePage,
  totalPages,
}) => {
  return (
    <>
      <PaginationWrapper>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, page) => handleChangePage(page)}
          variant="outlined"
          shape="rounded"
        />
      </PaginationWrapper>
    </>
  );
};

export default memo(TablePaginations);
